import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { validateToken, has_Permission } from '../../../helpers/jwt-token-access/accessToken'
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";

import { Button, Card, CardBody, Col, Container, Row, Spinner, ModalHeader, Modal,ModalBody, FormGroup, Label} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom"
import { BaseUrl } from "../../../helpers/Baseurl"

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';


class Signature extends Component {
  constructor(props) {
    super(props)
    this.state = {
        signature_id:"",
        alert_confirm : false,
        success_confirm : false,
        dynamic_title: "",
        dynamic_description: "",
        edit_signature:"",

        signatures: [],
        breadcrumbItems : [
            { title : "Planmans", link : "/dashboard" },
            { title : "Signatures", link : "#" },
        ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

    this.handleSignatureDelete = this.handleSignatureDelete.bind(this)
    this.tog_edit_signature = this.tog_edit_signature.bind(this)
    this.handleEditSignatureSubmit = this.handleEditSignatureSubmit.bind(this)
  }

  tog_edit_signature() {
    this.setState(prevState => ({
        model_edit_signature: !prevState.model_edit_signature
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }

  async componentDidMount() {
    document.title = "Signatures | Planmans"
    this.loadData();
 }

 async loadData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/cms/signatures/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              this.setState({ signatures: data, model_edit_signature:false, loading:false  })
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

  handleSignatureDelete = id => {   

    const requestOptions = {
      method: 'DELETE',
  
      };
        fetch(`${BaseUrl}/api/cms/signatures/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    this.loadData();
                    this.setState({
                      signature_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Signature has been deleted."
                      })
                      
                      
                  }
              }
          )

  }

  handleEditSignatureSubmit(e, values) {
    this.setState({ loading: true })
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values)
        };
        fetch(`${BaseUrl}/api/cms/signatures/${this.state.edit_signature.id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.setState({ loading: false })
                          }
                            
                      )
                  }
                  else{
                    this.loadData()
                  }    
              }
          )

  }

  render() {

    const { signatures ,edit_signature} = this.state
     console.log("")

    const { SearchBar } = Search

    //pagination customization
    let total_size = signatures.length 
    const pageOptions = {
      sizePerPage: 10,
      totalSize: total_size, // replace later with size(Order),
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const signaturesColumns = [
      {
        dataField: "id",
        text: "id",
        hidden: true,
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "designation",
        text: "Designation",
        sort: true,
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        Style: { float: 'left' },
        formatter: (cellContent, row) => (
          <React.Fragment>
            <Link to="#" onClick={() => this.setState({edit_signature:row, model_edit_signature:true }) } className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
            <Link to="#" onClick={() => this.setState({ alert_confirm: true, signature_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
            </React.Fragment>
        ),
      },
    ]

    return (
      <React.Fragment>
        <div className="page-content">
          
          <Container fluid>
          <Breadcrumbs title="All Signatures" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={signatures}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={signatures}
                          columns={signaturesColumns}
                          bootstrap4
                          search
                        >
                          
                          {toolkitProps => (
                            <React.Fragment>
                              
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() => this.props.history.push("/new-signature")}
                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      Add New Signature
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <div className="table-responsive">

                                <BootstrapTable
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  headerWrapperClasses={"table-light"}
                                />
                                
                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                              {this.state.alert_confirm ? (
                                                    <SweetAlert
                                                    title="Are you sure?"
                                                    warning
                                                    showCancel
                                                    confirmBtnBsStyle="success"
                                                    cancelBtnBsStyle="danger"
                                                    onConfirm={() => this.handleSignatureDelete(this.state.signature_id)}
                                                    onCancel={() =>
                                                        this.setState({
                                                            alert_confirm: false,
                                                            signature_id:"",

                                                        })
                                                    }
                                                    >
                                                    You won't be able to revert this!
                                                    </SweetAlert>
                                                ) : null}

                                               {this.state.success_confirm ? (
                                              <SweetAlert
                                              success
                                              title={this.state.dynamic_title}
                                              confirmBtnBsStyle="success"
                                              cancelBtnBsStyle="danger"
                                              onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                                              >
                                                  {this.state.dynamic_description}
                                              </SweetAlert>
                                          )
                                          : null
                                      }
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <Col sm={6} md={4} xl={3} className="mt-4">
               
          <Modal
            isOpen={this.state.model_edit_signature}
            toggle={this.tog_edit_signature}
            centered={true}
          >
            <ModalHeader toggle={() => this.setState({ model_edit_signature: false })}>
            Edit {edit_signature.name} Signature
            </ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleEditSignatureSubmit} >

              <Row>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="name">Name</Label>
                              <AvField
                                  name="name"
                                  placeholder="Name"
                                  type="text"
                                  errorMessage="Enter Itinerary Name"
                                  className="form-control"
                                  value= {edit_signature.name}
                                  validate={{ required: { value: true } }}
                                  id="name"
                                  
                              />
                              </div>
                          </Col> 
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="customer_name">Designation</Label>
                              <AvField
                                  name="designation"
                                  placeholder="Designation"
                                  type="text"
                                  errorMessage="Enter Designation"
                                  value= {edit_signature.designation}
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="designation"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>

                      <Row>
                          <Col md={6}>
                              <div className="mb-3">
                                  <AvField
                                      name="phone"
                                      label="Contact Number"
                                      placeholder="Contact Number"
                                      type="text"
                                      value= {edit_signature.phone}
                                      errorMessage="Enter Only Digits"
                                      validate={{
                                          required: { value: true },
                                      }}
                                      />
                              </div>
                          </Col>
                          <Col md="6">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="email">Email</Label>
                              <AvField
                                  name="email"
                                  placeholder="Customer Email"
                                  type="email"
                                  value= {edit_signature.email}
                                  errorMessage="Enter Customer Name"
                                  className="form-control"
                                  validate={{ required: { value: true } }}
                                  id="email"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>
                      <Row>
                          <Col md="12">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="address">Address</Label>
                              <AvField
                                  name="address"
                                  placeholder="Customer Address"
                                  type="text"
                                  value= {edit_signature.address}
                                  errorMessage="Enter Address"
                                  className="form-control"
                                  id="address"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>
                      <Row>
                          <Col md="12">
                              <div className="mb-3">
                              <Label className="form-label " htmlFor="website">Website</Label>
                              <AvField
                                  name="website"
                                  placeholder="Website"
                                  type="text"
                                  value= {edit_signature.website}
                                  errorMessage="Enter Website"
                                  className="form-control"
                                  id="website"
                                  
                              />
                              </div>
                          </Col> 
                      </Row>
      
                                  
                <FormGroup className="mb-0">
                  {this.state.loading?(
                    <Spinner className="me-2 mt-2" color="primary" />
                  ):(
                    <div>
                
                  <Button type="submit" color="primary" className="me-1">
                    Submit
                  </Button>
                  </div>
                    )}
                </FormGroup>     
              </AvForm>

            </ModalBody>
          </Modal>
        </Col>

      </React.Fragment>
    )
  }
}

export default Signature